module.exports = require.ensure([
  './input-sms.amd.vue'
], function () {
  return require('./input-sms.amd.vue');
});



// WEBPACK FOOTER //
// ./app/components/molecules/input-sms/input-sms.amd.js